import { z } from 'zod';
/** Códigos estáveis de erro: o front traduz pelo código, nunca pela mensagem. */
export const ERROR_CODES = [
    'VALIDATION_FAILED',
    'NOT_FOUND',
    'TENANT_NOT_FOUND',
    'TENANT_REQUIRED',
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'CONFLICT',
    'SLUG_INVALID',
    'SLUG_TAKEN',
    'RATE_LIMITED',
    'INVALID_CREDENTIALS',
    'MFA_INVALID',
    'MFA_REQUIRED',
    'SESSION_EXPIRED',
    'CSRF_FAILED',
    'SLOT_TAKEN',
    'INVITE_INVALID',
    'EMAIL_UNAVAILABLE',
    'WHATSAPP_UNAVAILABLE',
    'INSTAGRAM_UNAVAILABLE',
    'INTERNAL',
];
/** RFC 9457 — application/problem+json */
export const problemDetailsSchema = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    code: z.enum(ERROR_CODES),
    detail: z.string().optional(),
    instance: z.string().optional(),
    requestId: z.string().optional(),
    errors: z
        .array(z.object({ path: z.string(), message: z.string() }))
        .optional(),
});
//# sourceMappingURL=errors.js.map